"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CommonInput_1 = require("./CommonInput");
var deko_utilities_1 = require("deko-utilities");
function TextInput(_a) {
    var name = _a.name, type = _a.type, label = _a.label, prefix = _a.prefix, placeholder = _a.placeholder, autoComplete = _a.autoComplete, value = _a.value, handleChange = _a.handleChange, handleKeyDown = _a.handleKeyDown, handleOnBlur = _a.handleOnBlur, validateStandard = _a.validateStandard, errors = _a.errors, className = _a.className, inputClass = _a.inputClass, disabled = _a.disabled, tooltip = _a.tooltip, htmlProps = _a.htmlProps, onRef = _a.onRef;
    if (type === undefined) {
        type = 'text';
    }
    if (type === 'number') {
        var _handleChange_1 = handleChange;
        handleChange = function (event) {
            var val = event.target.value;
            if (!/^[0-9]{0,15}$/.test(val) && val !== '') {
                return;
            }
            return _handleChange_1({
                target: {
                    name: event.target.name,
                    value: parseInt(val, 10),
                }
            });
        };
    }
    if (type === 'tel') {
        var _handleChange_2 = handleChange;
        handleChange = function (event) {
            var val = event.target.value;
            if (!/^\+?[0-9]{0,11}$/.test(val) && val !== '') {
                return;
            }
            return _handleChange_2({
                target: {
                    name: event.target.name,
                    value: val,
                }
            });
        };
    }
    if (type === 'numeric-text') {
        var _handleChange_3 = handleChange;
        type = 'number';
        handleChange = function (event) {
            var val = event.target.value;
            if (!/^[0-9]*$/.test(val) && val !== '') {
                return;
            }
            return _handleChange_3({
                target: {
                    name: event.target.name,
                    value: val,
                }
            });
        };
    }
    var wrapperClass = ["text-input " + name.split('.').join('-') + " focus-on-child-label"];
    if (className) {
        wrapperClass.push(className);
    }
    var disabledStr;
    if (disabled === true) {
        disabledStr = 'disabled';
    }
    if (tooltip) {
        wrapperClass.push('has-tooltip');
    }
    var _handleOnBlur = validateStandard ? validateStandard : undefined;
    if (typeof handleOnBlur === 'function') {
        _handleOnBlur = function (event) {
            handleOnBlur(event);
            validateStandard ? validateStandard(event) : null;
        };
    }
    return (React.createElement(CommonInput_1.default, { name: name, label: label, className: wrapperClass.join(' '), errors: errors, disabled: disabled },
        prefix,
        React.createElement("input", __assign({ type: type, id: name, name: name, value: deko_utilities_1.maybe(value, ''), className: inputClass, autoComplete: autoComplete, disabled: disabledStr, onChange: handleChange, onBlur: _handleOnBlur, onKeyDown: handleKeyDown, placeholder: placeholder, "aria-label": label, "aria-invalid": typeof errors === 'string', "aria-describedby": name + "_error", ref: onRef }, htmlProps)),
        tooltip));
}
exports.default = TextInput;
